export interface Team {
  id: string; // UUID
  name: string;
  description?: string;
  code?: string;
  parentTeamId?: string;
  hierarchyPath?: string;
  level?: number;
  color?: string;
  logoUrl?: string;
  active: boolean;
  status?: string; // 'ACTIVE' | 'INACTIVE'
  memberCount?: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface TeamDetail extends Team {
  members: TeamMember[];
  subTeams: Team[];
}

export interface TeamMember {
  id: string; // UUID
  teamId: string;
  userId: number;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  teamRole: TeamRole;
  jobTitle?: string;
  department?: string;
  active: boolean;
  isContractor: boolean;
  contractorExpiresAt?: Date;
  joinedAt: Date;
  leftAt?: Date;
}

export enum TeamRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  MECHANIC = 'MECHANIC',
  RIDER = 'RIDER',
  ANALYST = 'ANALYST',
  MEMBER = 'MEMBER',
  VIEWER = 'VIEWER'
}

export interface CreateTeamRequest {
  name: string;
  description?: string;
  code?: string;
  parentTeamId?: string;
  color?: string;
  logoUrl?: string;
}

export interface UpdateTeamRequest {
  name?: string;
  description?: string;
  color?: string;
  logoUrl?: string;
  active?: boolean;
}

export interface AddTeamMemberRequest {
  userId: string; // UUID
  teamRole: TeamRole;
  jobTitle?: string;
  department?: string;
  isContractor?: boolean;
  contractorExpiresAt?: Date;
}

export interface InviteTeamMemberRequest {
  email: string;
  teamRole: TeamRole;
  message?: string;
}

export interface UpdateMemberRoleRequest {
  role: TeamRole;
}

export interface TeamInvitation {
  id: string;
  teamId: string;
  teamName: string;
  teamColor?: string;
  invitedBy: string;
  invitedUserId: string;
  email: string;
  role: TeamRole;
  status: 'pending' | 'accepted' | 'rejected' | 'expired';
  message?: string;
  token?: string;
  expiresAt: Date;
  createdAt: Date;
  acceptedAt?: Date;
  rejectedAt?: Date;
}

export interface UserTeam {
  team: Team;
  role: TeamRole;
  joinedAt: Date;
  isActive: boolean;
}
